import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { ExternalLink } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CachedReportsTab({ adminToken }) {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, pages: 1 });

  const fetchReports = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/reports`, { params: { page, limit: 20 }, headers: { Authorization: `Bearer ${adminToken}` } });
      setReports(res.data.reports || []);
      setPagination({ total: res.data.total, pages: res.data.pages });
    } catch (err) { if (err.response?.status === 401) window.location.reload(); }
  }, [page, adminToken]);

  useEffect(() => { fetchReports(); }, [fetchReports]);

  return (
    <Card className="bg-white border-[#E5E7EB]">
      <CardHeader><CardTitle className="text-lg text-[#111827]">Cached Reports ({pagination.total})</CardTitle></CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-[#E5E7EB] bg-[#F9FAFB]">
              <TableHead className="text-[#6B7280]">Business</TableHead>
              <TableHead className="text-[#6B7280]">Address</TableHead>
              <TableHead className="text-center text-[#6B7280]">Score</TableHead>
              <TableHead className="text-[#6B7280]">Cached At</TableHead>
              <TableHead className="text-right text-[#6B7280]">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {reports.length > 0 ? reports.map((r, i) => (
              <TableRow key={r.place_id || i} className="border-[#E5E7EB]">
                <TableCell className="font-medium text-[#111827]">{r.business_name}</TableCell>
                <TableCell className="text-sm text-[#6B7280] truncate max-w-[250px]">{r.address}</TableCell>
                <TableCell className="text-center"><Badge className={r.overall_score >= 70 ? "bg-emerald-50 text-emerald-600" : r.overall_score >= 40 ? "bg-amber-50 text-amber-600" : "bg-red-50 text-red-600"}>{r.overall_score}</Badge></TableCell>
                <TableCell className="text-sm text-[#6B7280]">{new Date(r.cached_at).toLocaleString()}</TableCell>
                <TableCell className="text-right"><Button variant="ghost" size="sm" onClick={() => navigate(`/report/${r.place_id}`)} className="text-[#3B5BDB]"><ExternalLink className="w-4 h-4" /></Button></TableCell>
              </TableRow>
            )) : <TableRow><TableCell colSpan={5} className="text-center py-8 text-[#9CA3AF]">No cached reports</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
